import { useTranslation } from "react-i18next";
import { useCalcPriceQuery } from "../../../api/queries/priceQueries";
import { useMoney } from "../../../hooks/useMoney";
import { PriceRow } from "./PriceRow";

export const CartPriceDetail = ({
  bookingPrice,
}: {
  bookingPrice: ReturnType<typeof useCalcPriceQuery>;
}) => {
  const { formatMoney } = useMoney();

  const { t } = useTranslation();
  const voucherDiscountAmount = bookingPrice.data?.voucherAmount ?? 0;
  const beforeServiceFeeTotalOfOrder =
    bookingPrice.data?.beforeServiceFeeTotalOfOrder ?? 0;
  const beforeServiceFeeTotal = bookingPrice.data?.beforeServiceFeeTotal ?? 0;
  const serviceChargeAmount = bookingPrice.data?.serviceFeeAmount ?? 0;
  const paidAmount = bookingPrice.data?.paidAmount ?? 0;
  return (
    <>
      <TtLine />
      <div className="flex flex-col items-start gap-[1.50rem]">
        <h6 className="undefined text-[1.13rem] font-semibold text-[#5E6D77]">
          {t("Price Detail")}
        </h6>
        <PriceRow
          label={t("Subtotal")}
          value={
            beforeServiceFeeTotal +
            beforeServiceFeeTotalOfOrder +
            (voucherDiscountAmount ?? 0)
          }
        />
        {beforeServiceFeeTotalOfOrder > 0 && (
          <>
            <PriceRow
              label={t("Paid amount")}
              negative={true}
              value={beforeServiceFeeTotalOfOrder}
            />
            <PriceRow label={t("Amount due")} value={beforeServiceFeeTotal} />
          </>
        )}
        {/* {productAndPassDiscountAmount > 0 && (
          <PriceRow
            negative={true}
            label={t("Product discount")}
            value={productAndPassDiscountAmount}
          />
        )} */}
        {voucherDiscountAmount > 0 && (
          <PriceRow
            negative={true}
            label={t("Promote code") + " " + t("discount")}
            value={voucherDiscountAmount}
          />
        )}
        {!!serviceChargeAmount && (
          <PriceRow
            label={t("VAT & Service charge")}
            value={serviceChargeAmount}
          />
        )}
      </div>
      <TtLine />
      <div className="flex items-center justify-between">
        <span className="self-end text-[1.13rem] font-semibold text-gray-900">
          {t("Total payment")}
        </span>
        <span className="text-[1.25rem] font-bold text-gray-900">
          {formatMoney(paidAmount)}
        </span>
      </div>
    </>
  );
};

const TtLine = () => <div className="h-[0.06rem] bg-gray-300"></div>;
